import { FetchHelper } from "shared-ts-utils-fetch";
import { EnvironmentBuildingsDto } from "./EnvironmentBuildings";
import { AddressIdResolver } from "firefly-shared-ts-domain";
import { BuildingDto } from "./Building";
import { Settings } from "luxon";

export class BuildingDao {
  private readonly fetchHelper: FetchHelper;

  constructor() {
    this.fetchHelper = new FetchHelper({
      basePath: "/api/building/",
    });
  }

  getMyBuildings(
    refreshCache?: boolean
  ): Promise<Array<EnvironmentBuildingsDto>> {
    return this.fetchHelper
      .addHeader("Time-Zone", Settings.defaultZone.name)
      .get(
        "get-my-buildings" + (refreshCache === true ? "?refreshCache=true" : "")
      )
      .transformer<Array<EnvironmentBuildingsDto>>((response) => {
        return response.map((environmentBuildings) => {
          return {
            ...environmentBuildings,
            buildings: environmentBuildings.buildings.map((building) => {
              const addressId = AddressIdResolver.resolveAddressId({
                municipalityId: building.address.municipality.id,
                postalCode: building.address.postalAddress.code,
                streetAddress: building.address.streetAddress,
                cadastralAddress: building.address.cadastralAddress,
              });
              return {
                chimneys: building.chimneys,
                address: { ...building.address, id: addressId },
              } as BuildingDto;
            }),
          } as EnvironmentBuildingsDto;
        });
      })
      .fetchAsJson();
  }
}
